import axios from "axios";
import {STATIONNAIRE_API, STATION_SETTING_API, BUSES_API} from "../../config";
import Cache from "../cache";
//import * as assert from "assert";

async function findSetting() {
    // const cachedCustomSetting = await Cache.get("CustomSetting");
    // if(cachedCustomSetting) return cachedCustomSetting;
    return axios
        .get(STATION_SETTING_API)
        .then(response => {
            const setting = response.data.setting;
            //Cache.set("CustomSetting", setting);
            return response.data.setting;
        });
}

async function getMyConsumptions() {
    return axios
        .get(STATIONNAIRE_API + "/myConsumptions")
        .then(response => {
            return response.data.carburants;
        });
}

async function getMyDailyConsumptions() {
    return axios
        .get(STATIONNAIRE_API + "/myDailyConsumptions")
        .then(response => {
            return response.data.carburants;
        });
}

async function getMyMounthlyConsumptions() {
    return axios
        .get(STATIONNAIRE_API + "/myMounthlyConsumptions")
        .then(response => {
            return response.data.carburants;
        });
}

function storeConsumption(station){

    return axios.post(STATIONNAIRE_API + "/storeConsumption", station)
        .then(async response => {
            return response;
        });
}


async function findStation() {
    return axios
        .get(STATIONNAIRE_API + "/getStation")
        .then(response => {
            return response.data.station;
        });
}

async function findAllBuses() {
    return axios
        .get(STATIONNAIRE_API + "/buses")
        .then(response => {
            return response.data.buses;
        });
}

async function findAllDrivers() {
    return axios
        .get(STATIONNAIRE_API + "/drivers")
        .then(response => {
            return response.data.drivers;
        });
}

export default {
    getMyConsumptions,
    getMyDailyConsumptions,
    getMyMounthlyConsumptions,
    findAllBuses,
    findAllDrivers,
    findSetting,
    storeConsumption,
    findStation,
};